import { IPageFilter } from "../../store/queries/page-filter.interface";
import { ITaskFilters } from "./task.reducer";
import { Task } from "./task.model";
import { itemSelector, listSelector, Qry } from "../query-facade";
import { VasState } from "../../store/store-type";
import { createSelector } from "reselect";
import { Job } from "../job/job.model";
import { getSortByFn } from "../../../core/util/utils";
import { isDefined } from "ionic-angular/util/util";

export class TaskPageFilter implements IPageFilter<Task, ITaskFilters> {

    constructor(protected qry: Qry) {

    }

    createSelector(itemsSelector: listSelector<Task>, filterSelector: itemSelector<ITaskFilters>): (state: VasState) => Array<Task> {
        return createSelector(
            this.qry.task.byActiveAccount,
            this.qry.job.items,
            filterSelector,
            (tasks: Array<Task>, jobs: Array<Job>, filters: ITaskFilters) => {

                return tasks
                    .filter(task => {
                        if (!isDefined(filters.done)) {
                            return true;
                        }

                        return filters.done === task.done;
                    })
                    .filter(task => {

                        if (!filters.taskType) {
                            return true;
                        } else {
                            return task.taskType === filters.taskType;
                        }
                    })
                    .filter(task => {

                        if (!filters.searchTerm) {
                            return true;
                        }

                        if (task.title.toLowerCase().indexOf(filters.searchTerm.toLowerCase()) !== -1) {
                            return true;
                        }

                        const job = jobs.find(j => j.id === task.job);

                        if (job && job.reference.toLowerCase().indexOf(filters.searchTerm.toLowerCase()) !== -1) {
                            return true;
                        }

                        return false;
                    })
                    .sort(getSortByFn(filters.sortBy, filters.sortDirection, (sortBy: string, task: Task) => {

                        switch (sortBy) {
                            case "job": {
                                const job = jobs.find(j => j.id === task.job);

                                if (!job) {
                                    return undefined;
                                }

                                return job.reference;
                            }
                            default: {
                                return task[sortBy];
                            }
                        }
                    }));
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task.page-filter.ts